import { render, staticRenderFns } from "./TestProtocol.vue?vue&type=template&id=822da04e&scoped=true&"
import script from "./TestProtocol.vue?vue&type=script&lang=js&"
export * from "./TestProtocol.vue?vue&type=script&lang=js&"
import style0 from "./TestProtocol.vue?vue&type=style&index=0&id=822da04e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822da04e",
  null
  
)

export default component.exports